import {
  freshData
} from "@/api/user";
import {
  login as userApiLogin,
  loginStu as userApiloginStu
} from "@/api/userApi";
import {
  authNewLogin
} from "@/api/admin";
import { api_tchSelectTchListByEdu } from '@/api/javaApi'

import { setNavChildren } from '@/utils/utils'
import CryptoJS from 'crypto-js'

const user = {
  state: {
    username: "",
    token: "",
    adminUserName: "",
    adminToken: "",
    is_principal: "", //是不是超级校长
    roleList: [],
    selected_schools: [],
    permisionList: [],

    adminpermisionList: [],

    userInfo: {},
    schoolInfo: {},
    identity: "",   //身份信息  1为员工 2为学生

    eduTchList: [] // 机构教师列表

  },
  mutations: {
    SET_USERNAME: (state, data) => {
      state.username = data;
    },
    SET_TOKEN: (state, data) => {
      state.token = data;
    },

    SET_ROLE: (state, data) => {
      state.roleList = data;
    },

    SET_PERMISION: (state, data) => {
      if (data) {
        data.forEach(permision => {
          if (permision.name === '星币管理') {
            permision.hide = !state.schoolInfo.pointAuth
          }
        })
      }
      state.permisionList = data;
    },

    SET_ADMINPERMISION: (state, data) => {
      state.adminpermisionList = data;
    },

    SET_USERINFO: (state, data) => {
      state.userInfo = data;
    },

    SET_SCHOOLINFO: (state, data) => {
      state.schoolInfo = data;
    },

    SET_SELECTSCHOOL: (state, data) => {
      state.selected_schools = data;
    },

    SET_PRINCIPAL: (state, data) => {
      state.is_principal = data;
    },

    SET_IDENTITY: (state, data) => {
      state.identity = data;
    },

    RESET_PRINCIPAL: (state) => {
      state.is_principal = "";
    },


    RESET_IDENTITY: (state) => {
      state.identity = "";
    },


    RESET_ROLE: (state) => {
      state.roleList = [];
    },

    RESET_PERMISION: (state) => {
      state.permisionList = [];
    },

    RESET_ADMINPERMISION: (state) => {
      state.adminpermisionList = [];
    },

    RESET_USER: (state) => {
      state.username = '',
        state.token = '',
        state.roleList = [],
        state.permisionList = [],
        state.is_principal = "",
        state.selected_schools = [],
        state.permisionList = [],
        state.userInfo = {},
        state.schoolInfo = {},
        state.identity = ""
    },
    SET_ADMINUSERNAME: (state, data) => {
      state.adminUserName = data;
    },
    SET_ADMINTOKEN: (state, data) => {
      state.adminToken = data;
    },
    RESET_ADMINUSER: (state) => {
      state.adminUserName = ''
      state.adminToken = ''
    },
    SET_EDUTCHLIST: (state, data) => {
      state.eduTchList = data;
    }
  },
  actions: {
    tchSelectTchListByEdu({ commit }) {
      api_tchSelectTchListByEdu().then(res => {
        commit('SET_EDUTCHLIST', res)
      })
    },
    // 用户名登录，获取用户信息
    LoginByUsername({
      dispatch,
      commit
    }, loginForm) {
      return new Promise((resolve) => {
        userApiLogin({
          userName: loginForm.username,
          password: CryptoJS.MD5(loginForm.password).toString(CryptoJS.enc.Base64),
          captchaVerifyParam: loginForm.captchaVerifyParam
        }).then(async data => {
          let authTree = window.JSON.parse(data.authTree)
          if (authTree) {
            authTree = setNavChildren(authTree.children, true)
          }
          commit("SET_IDENTITY", 1);
          commit("SET_PERMISION", authTree || "");
          await commit("SET_TOKEN", data.token || "");
          dispatch('freshUserData').then(res => {
            console.log(res)
            resolve('success');
          })
          dispatch('tchSelectTchListByEdu');
        }).catch((error) => {
          resolve(error.code);
        });
      });
    },

    // 用户名登录，获取用户信息 - 学生
    LoginStuByUsername({
      dispatch,
      commit
    }, loginForm) {
      return new Promise((resolve) => {
        userApiloginStu({
          userName: loginForm.username,
          password: CryptoJS.MD5(loginForm.password).toString(CryptoJS.enc.Base64),
          captchaVerifyParam: loginForm.captchaVerifyParam
        }).then(data => {
          // let authTree = window.JSON.parse(data2.authTree)
          // console.log(authTree)
          // if (authTree) {
          //   authTree = setNavChildren(authTree.children)
          // }
          commit("SET_IDENTITY", 2);
          commit("SET_TOKEN", data || "");
          commit("SET_PRINCIPAL", false);
          commit("SET_ROLE", "");
          dispatch('freshUserData').then(res => {
            console.log(res)
            resolve('success');
          })
        }).catch((error) => {
          resolve(error.code);
        });
      });
    },
    // 刷新用户数据
    async freshUserData({ state, commit }) {
      return freshData().then(res => {
        console.log('登陆后第一次初始化用户信息的freshData接口')
        if (res.identity == 1) {
          console.log('员工账号')
          commit('SET_IDENTITY', res.identity || '')
          commit('SET_USERINFO', res.userInfo || '')
          commit('SET_SCHOOLINFO', res.schoolInfo || '')
          console.log(state)
          if (state.permisionList && state.permisionList.join('') !== '') {
            commit('SET_PERMISION', state.permisionList)
          }
          commit('SET_USERNAME', res.userInfo.realName || '')
          commit('SET_PRINCIPAL', res.userInfo.principal || '')
          commit('SET_ROLE', res.roleList || '')
        } else if (res.identity == 2) {
          console.log('学生账号')
          commit('SET_IDENTITY', res.identity || '')
          commit(
            'SET_USERNAME',
            res.userInfo.stuUserInfo.realName || ''
          )
          commit('SET_USERINFO', res.userInfo || '')
          commit('SET_SCHOOLINFO', res.schoolInfo || '')
          commit('SET_PRINCIPAL', false)
          commit('SET_ROLE', '')
        }
        return res;
      })
    },
    // 登出
    LogOut({
      commit
    }) {
      return new Promise((resolve) => {
        commit('RESET_USER')
        //localStorage.removeItem('vuex')
        resolve()
      })
    },
    // 用户名登录，获取用户信息
    LoginByAdminUsername({
      commit
    }, loginForm) {
      return new Promise((resolve, reject) => {
        authNewLogin({
          username: loginForm.username,
          password: loginForm.password,
        })
          .then((data) => {
            console.log(data)
            commit("SET_ADMINUSERNAME", data.userRealname || "");
            commit("SET_ADMINTOKEN", data.token || "");
            commit("SET_ADMINPERMISION", data.authUserPermission || "")

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 登出
    AdminLogOut({
      commit
    }) {
      return new Promise((resolve) => {
        commit('RESET_ADMINUSER', "")
        // localStorage.removeItem('vuex')
        resolve()
      })
    }

  }
};

export default user;